const GET_ALL_AVAILABLE_FORMS = '/webservice/get-update-booking-question';
const DELETE_ATTACHMENT_FOR_FORM_QUESTION = '/calendar/delete-question-attachments';
const STORE_IMAGE_TO_TEMP_BUCKET = '/api/v2/attachments/presigned-upload-url';
const GRt_BUCKET_LINK = 'webservice/get-bucket-link';
const EDIT_FORM_AND_CHECKLIST = 'booking/edit-form-and-checklist';
const EDIT_FORM_AND_CHECKLIST_FOR_INQUIRY = 'inquiry/edit-custom-fields';
const UPDATE_FOLLOW_UP_DATE = '/follow-up';
const CHANGE_FOLLOW_UP_DATE = '/change_follow_up';
const CHANGE_FOLLOW_UP_DATE_FOR_INQUIRY = '/change_follow_up-for-inquiry';
const UPDATE_Expiry_DATE = '/expiry-date';
const CHANGE_Expiry_DATE = '/change-expiry-date';
const UPDATE_SINGLE_FORM = '/webservice/update-single-form';
const DELETE_SINGLE_FORM = '/webservice/delete-single-form';

function resolveLaravelBase() {
    if (typeof window !== 'undefined' && window.LARAVEL_BASE) {
        return String(window.LARAVEL_BASE).replace(/\/$/, '');
    }
    if (typeof LARAVEL_BASE !== 'undefined' && LARAVEL_BASE) {
        return String(LARAVEL_BASE).replace(/\/$/, '');
    }
    return 'https://octopuspro.test:9001';
}

function resolveJwtToken() {
    if (typeof window !== 'undefined' && window.JWT_TOKEN) {
        return window.JWT_TOKEN;
    }
    if (typeof JWT_TOKEN !== 'undefined' && JWT_TOKEN) {
        return JWT_TOKEN;
    }
    if (typeof window !== 'undefined' && window.__OCTOPUS_SESSION_JWT) {
        return window.__OCTOPUS_SESSION_JWT;
    }
    return '';
}

function ensureJwtToken() {
    const existing = resolveJwtToken();
    if (existing) {
        return Promise.resolve(existing);
    }
    return window.axios
        .get('/api/nuxt/session', { params: { path_name: window.location.pathname } })
        .then(function (response) {
            const token =
                (response && response.data && response.data.JWT && response.data.JWT.token) ||
                (response && response.data && response.data.JWT) ||
                '';
            if (token && typeof token === 'string') {
                window.__OCTOPUS_SESSION_JWT = token;
                window.JWT_TOKEN = token;
                return token;
            }
            return '';
        })
        .catch(function () {
            return '';
        });
}

module.exports = {
    getAvailableForms: function getAvailableForms(bookingId = 0, status_id = 0, contractors = [],services =[],displayOptionId = 0,firstLoadOnView = 0) {
        return window.axios.get(GET_ALL_AVAILABLE_FORMS, {

            params: {
                'booking_id': bookingId,
                'when_to_display': displayOptionId,
                'status_id': status_id,
                'services': services,
                'contractors': contractors,
                'first_load_on_view': firstLoadOnView,
            }
        });
    },
    getBucketLink: function getBucketLink(){
        return window.axios.get(GRt_BUCKET_LINK);
    },
    deleteAttachment: function deleteAttachment(attachmentId){
        return window.axios.get(DELETE_ATTACHMENT_FOR_FORM_QUESTION,{params:{'attachment_id':attachmentId}})
    },
    uploadSignature: function uploadSignature({image, customer_id, attribute_id}) {
        let image_type = 'signature';
        const formData = new FormData();
        formData.append('image', image);
        formData.append('customer_id', customer_id);
        formData.append('attribute_id', attribute_id);
        formData.append('image_type', image_type);
        formData.append('for_ajax', true);
        return ensureJwtToken().then(function (jwtToken) {
            const headers = {};
            if (jwtToken) {
                headers['Authorization'] = 'Bearer ' + jwtToken;
            }
            return window.axios.post(
                resolveLaravelBase() + STORE_IMAGE_TO_TEMP_BUCKET,
                formData,
                { headers: headers }
            );
        });
    },

    editFormAndChecklist: function editFormAndChecklist(bookingId, formData) {
        return window.axios.post(EDIT_FORM_AND_CHECKLIST + '/' + bookingId, formData, {
            responseType: 'json', // default
        });
    },
    editFormAndChecklistForInquiry: function editFormAndChecklistForInquiry(inquiryId, formData) {
        return window.axios.post(EDIT_FORM_AND_CHECKLIST_FOR_INQUIRY + '/' + inquiryId, formData, {
            responseType: 'json', // default
        });
    },
    updateFollowUpDate:function updateFollowUpDate(bookingId = 0,date){
        const formData = new FormData();
        formData.append('followDate', date);
        const url = UPDATE_FOLLOW_UP_DATE + '/' + bookingId+'?type=booking';
        return window.axios.post(url, formData);
    },
    updateExpiryDate:function updateExpiryDate(bookingId = 0,date){
        const formData = new FormData();
        formData.append('expiryDate', date);
        const url = UPDATE_Expiry_DATE + '/' + bookingId;
        return window.axios.post(url, formData);
    },
    changeFollowUp: function changeFollowUp(bookingId = 0,to_follow= 0){
        let toFollow = 0;
        if (to_follow){
            toFollow = 1;
        }
       const url = CHANGE_FOLLOW_UP_DATE +'/' + bookingId+'/' +toFollow+'?type=booking&forAjax=1';
       return window.axios.get(url);
    },
    changeExpiryDate: function changeExpiryDate(bookingId = 0,value = false){
        let expiyDate = 0;
        if (value){
            expiyDate = 1;
        }
       const url = CHANGE_Expiry_DATE +'/' + bookingId+'/'+expiyDate;
       return window.axios.get(url);
    },
    updateFollowUpDateForInquiry:function updateFollowUpDateForInquiry(inquiryId = 0,date){
        const formData = new FormData();
        formData.append('followDate', date);
        const url = UPDATE_FOLLOW_UP_DATE + '/' + inquiryId+'?type=inquiry';
        return window.axios.post(url, formData);
    },
    changeFollowUpForInquiry: function changeFollowUpForInquiry(inquiryId = 0,to_follow= 0){
        let toFollow = 0;
        if (to_follow){
            toFollow = 1;
        }
        const url = CHANGE_FOLLOW_UP_DATE_FOR_INQUIRY +'/' + inquiryId+'/' +toFollow+'?type=inquiry&forAjax=1';
        return window.axios.get(url);
    },
    updateSingleForm:function updateSingleForm(data){
        const url = UPDATE_SINGLE_FORM;
        const formData = new FormData();
        formData.append('quetions', data);
        return window.axios.post(url, formData);
    },
    deleteSingleForms: function deleteSingleForms(data = 0) {
        const url = DELETE_SINGLE_FORM;
        const formData = new FormData();
        formData.append('data', data);
        return window.axios.post(url, formData);
    },
};
